<template>
  <div class="animated fadeIn">
    <div class="row no">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div class="title_head">
              Product Barcode
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">Add Product to generate barcode</label>
                  <model-list-select :list="productnamex" @searchchange="searchprd3($event)" @input="onSelect($event)" v-model="selectproductrow" option-value="product_id" option-text="product_name" placeholder="Search Product"></model-list-select>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">&nbsp;</label><br>
                  <button type="button" class="btn btn-primary btn-pill" @click="searchPurchase"><i class="fa fa-search"></i>&nbsp;Search Purchase</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <table class="table table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="1%">#</th>
                      <th width="5%">Product Name</th>
                      <th width="3%">Quantity</th>
                      <th width="1%">Delete</th>
                    </tr>
                  </thead>
                  <tbody v-if="rows.length != 0">
                    <tr v-for="(row, index) in rows">
                      <td>{{index+1}}</td>
                      <td><label>{{row.product_name}}</label></td> 
                      <td><input type="text" v-model="row.qty" class="form-control-sm" :class="{'is-invalid':qtyErr[index]}" @input="check(row.qty,index)"><br>
                        <small class="help-block" v-if="qtyErr[index]" ><strong style="color: red; font-weight: normal;">{{qtyErr[index]}}</strong></small>
                      </td>
                      <td><i class="fa fa-trash-o" style="color: #F44336;" v-on:click="removeElement(index);"></i></td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr><td colspan="4" style="text-align:center;">No Records Found</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <b-form-checkbox name="pname" id="pname" value="true" unchecked-value="false" @input="selectProductName()">Product Name</b-form-checkbox>
                <b-form-checkbox name="cname" id="cname" value="true" unchecked-value="false" @input="selectCompanyName()">Company Name</b-form-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 text-center">
                <button class="btn btn-sm btn-primary btn-pill" type="button" @click="generateBarcode"><i class="fa fa-cog"></i> Generate</button>
                <button class="btn btn-sm btn-primary btn-pill" type="button" @click="printBarcode()" ><i class="fa fa-print"></i> Print</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row" v-if="rows1.length > 0">
      <div class="col-sm-12" style="background-color: white;">
        <div v-for="(row, index) in rows1" class="d-inline-flex p-3" id="id1">
          <div style="text-align:center;" class="p-2 my-flex-item" :class="{'page-break':num == index}">
            <barcode v-model="row.barcode" :options="options" class="barcode"></barcode>
            <small v-if="showName==true" style="position:relative; top:-15%; font-size:12px; font-family: monospace;font-weight: normal;"><br>{{row.product_name}}</small>
            <small v-if="showCompany==true && showName==true" style="position: relative;top: -21%; font-size: 12px; font-family: monospace;font-weight: normal;"><br>{{company_name}}</small>
            <small v-if="showCompany==true && showName==false" style="position: relative;top: -15%; font-size: 12px; font-family: monospace;font-weight: normal;"><br>{{company_name}}</small>
          </div>
        </div>
      </div>
    </div>

    <b-modal title="Purchase Items" no-close-on-esc no-close-on-backdrop size="lg" hide-footer class="modal-warning" v-model="PurchaseItemModal" @ok="PurchaseItemModal = true" ok-variant="warning">
      <b-collapse id="collapse1" visible>
        <div class="row">
          <b-col sm="3">
            <b-form-group>
              <label for="name">Purchase Id</label><br>
              <b-form-input type="text" placeholder="Enter Purchase Id" v-model="purchase_id"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group>
              <label for="name">&nbsp;</label><br>
              <button type="button" class="btn btn-primary btn-pill" @click="submitPurchaseId"><i class="fa fa-search"></i>&nbsp;Search</button>
            </b-form-group>
          </b-col>
        </div>
        <vue-good-table :columns="columns" :rows="rows2" mode="remote" ref="my-table" :search-options="{ enabled: false }" @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange" @on-selected-rows-change="selectedItems($event)" @on-column-filter="onColumnFilter" :select-options="{ enabled: true }" styleClass="vgt-table striped bordered table-sm condensed" :totalRows="totalRecords" :pagination-options="{enabled: true, perPage: 5}">
          <template slot="table-row" slot-scope="props">
            {{props.formattedRow[props.column.field]}}
          </template>
        </vue-good-table>
        <div class="row">
          <b-col sm="12">
            <b-form-group>
              <label for="name">&nbsp;</label><br>
              <button class="btn btn-sm btn-primary btn-pill pull-right" type="button" @click="onSave()"><i class="fa fa-plus"></i> Add</button>
            </b-form-group>
          </b-col>
        </div>
      </b-collapse>
    </b-modal>

  </div>
</template>

<script>
export default {
  name: 'my-component',
  data(){
    return {
      serverParams: {
        columnFilters: {},
        sort: {
          field: 'purchase_id', 
          type: 'asc',
        },
        page: 1, 
        perPage: 5
      },
      purchase_id:null,
      totalRecords:0,
      PurchaseItemModal:false,
      productnamex:[],
      selectproductrow:null,
      objectItem: null,
      rows:[],
      currentIndex:0,
      rows1:[],
      rows2:[],
      itemList:[],
      showCompany:false,
      showName:false,
      company_name:'',
      barcode_setting:0,
      num:0,
      qtyErr:[],
      options:{
        fontSize:13,
        height: 40,
        width: 2,
      },
      columns: [
      {
        label: 'Product Name',
        field: 'product_name',
        width: '25% !important'
      },
      {
        label: 'Variant',
        field: 'variant_id',
        width: '15% !important'
      },
      {
        label: 'Qty',
        field: 'purchase_qty',
        width: '10% !important'
      },
      {
        label: 'Price',
        field: 'product_unit_cost',
        width: '10% !important',
        formatFn: this.formatFn
      },
      {
        label: 'Tax',
        field: 'tax_inclusive',
        width: '10% !important'
      },
      {
        label: 'GST%',
        field: 'gst_total',
        width: '15% !important'
      },
      {
        label: 'Amount',
        field: 'amt_to_pay',
        width: '15% !important',
        formatFn: this.formatFn
      },
      ],
    };
  },
  
  methods: {
    selectedItems(items){
      var len = items.selectedRows.length
      var _this = this
      this.itemList = []
      for(var i=0;i<len;i++){
        var temp = items.selectedRows[i]
        _this.itemList.push({product_name:temp.product_name, qty:1, selectedproductid:temp.product_id, product_barcode_symbol:temp.item_barcode})
      }
    },

    submitPurchaseId(){
      if(this.purchase_id){
        var _this = this
        var data = []
        var filteParam = {};
        filteParam.page = this.serverParams.page;
        filteParam.perPage = this.serverParams.perPage;
        filteParam.sort = this.serverParams.sort;
        data = data + " &filter[where][purchase_id]="+this.purchase_id
        this.$http.get('/api/purchasedetails/searchdb?params='+JSON.stringify(filteParam)+data)
        .then(function (response) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift()
          if(response.data != undefined)
            _this.rows2=response.data
        })
      }
    },

    searchPurchase(){
      this.PurchaseItemModal = true;
      this.purchase_id = null,
      this.totalRecords = 0,
      this.rows2 = []
    },

    formatFn(value) {
      return parseFloat(value).toFixed(2);
    },

    removeElement: function(index) {
      this.rows.splice(index, 1);
      this.generateBarcode()
    }, 

    onPageChange(params) { 
      this.updateParams({page: params.currentPage});
      this.submitPurchaseId();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage,page:1});
      this.submitPurchaseId();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },page:1
      });
     this.submitPurchaseId();
    },
    
    onColumnFilter(params) {
      this.updateParams(params);
      this.submitPurchaseId();
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    check(val,indx){
      var num1=/^([1-9][0-9]{0,2}|1000)$/
      if(val == ""){
        this.qtyErr[indx] = 'Required'
      }
      else if(val <= 0){
        this.qtyErr[indx] = 'Quantity should be grater than zero'
      }
      else if(num1.test(val)==false){
        this.qtyErr[indx] = 'Enter Valid Quantity'
      }
      else{
        this.qtyErr[indx] = ''
      }
    },

    printBarcode(){
      window.print()
    },

    onSave(){
      var temp = this.itemList;
      if(temp.length > 0){
        for(var i=0; i < temp.length; i++){
          this.rows.push({product_name:temp[i].product_name,qty:1,selectedproductid:temp[i].product_id,barcode:temp[i].product_barcode_symbol})
          this.currentIndex = parseInt(this.currentIndex)+1
        }
      }
    },

    onSelect(option){
      if(option.product_name){
        this.rows.push({product_name:option.product_name,qty:1,selectedproductid:option.product_id,barcode:option.product_barcode_symbol})
        this.currentIndex = parseInt(this.currentIndex)+1
        this.selectproductrow = null;
      }
    },

    generateBarcode(){
      var _this = this
      this.num = parseInt(this.barcode_setting)-1
      this.rows1=[]
      for(var i=0;i<this.rows.length;i++){
        for(var j=0;j<this.rows[i].qty;j++){
          this.rows1.push({barcode:_this.rows[i].barcode,product_name:_this.rows[i].product_name})
        }
      }
    },

    selectProductName(){
      if(document.getElementById('pname').checked){
        this.showName = true
      }else{
        this.showName = false
      }
    },

    selectCompanyName(){
      var _this = this
      this.$http.get('/api/companies/findOne').then(function(response){
        _this.company_name=response.data.company_name
      });
      if(document.getElementById('cname').checked){
        this.showCompany =true
      }else{
        this.showCompany = false
      }
    },

    searchprd3(searchText){
      var _this = this
        this.$http.get('/api/purchasereturns/joinproduct2?data='+searchText).then(function (response) {
        _this.productnamex=response.data
      }).catch(function (error) {
        console.log(error);  
      });
    }

  },
}
</script>


<style type="text/css">
  @media print {
    .no {
      display: none !important;
    }
    .breadcrumb{
      display: none !important 
    }
    .app-footer{
      display:none !important
    }
    .page-break{ 
      pageBreakAfter :always;
      color:red; 
    }
  }

  @media print and (width: 5.83in) and (height: 8.27in) {
    @page {
      margin: 1in;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/product/barcode.vue